module.exports = "<template>\n    <div>\n       <p> <vbl-textarea placeholder=\"提示\" v-model=\"val\"></vbl-textarea></p>\n       <br/>\n       禁用\n       <p> <vbl-textarea placeholder=\"提示\" v-model=\"val2\" disabled></vbl-textarea></p>\n    </div>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                val: '',\n                val1: '',\n                val2: ''\n            };\n        }\n    }\n</script>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/vblTextarea/example/vblTextareaExample.vue
// module id = 179
// module chunks = 0